/** Where Find Imports lists the site's imports of users. */
export const userImportsPath = '/site-management/users/imports'

/** Where Import Users starts one. */
export const importUsersPath = `${userImportsPath}/new`

/** An import's report page. */
export const userImportRoute = `${userImportsPath}/:publicId`

/** An import's report. */
export function userImportPath(id: string): string {
  return `${userImportsPath}/${encodeURIComponent(id)}`
}

/** The API's imports: GET lists them, POST starts one. */
export const userImportsApi = '/site-management/v1/users/imports'

/** The template: the header alone. */
export const userImportTemplateApi = `${userImportsApi}/template`

/** Where the browser asks for a link to upload a file to. */
export const userImportUploadLinkApi = `${userImportsApi}/upload-link`

/** An import. */
export function userImportApi(id: string): string {
  return `${userImportsApi}/${encodeURIComponent(id)}`
}

/** An import's rows, the report; its export is at `${userImportRowsApi(id)}/export`. */
export function userImportRowsApi(id: string): string {
  return `${userImportApi(id)}/rows`
}

/** Importing people from a file, and seeing what an import did. */
export const bulkImportPermission = 'site-management.user-profiles.bulk-import.write'
